var map = {
	"./": 466,
	"./development": 1397,
	"./development.js": 1397,
	"./index": 466,
	"./index.js": 466,
	"./preprod": 1398,
	"./preprod.js": 1398,
	"./production": 1378,
	"./production.js": 1378,
	"./staging": 1399,
	"./staging.js": 1399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3388;